import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AudioFormComponent } from './audio-form/audio-form.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [AudioFormComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [AudioFormComponent],
})
export class AudioModule { }
